module.exports = __webpack_public_path__ + "img/shortly.45f63772.svg";